module.exports = __webpack_public_path__ + "ac6c37970302886b01b2184cee3f5fe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2084_teaser_image.jpg
// module id = 590
// module chunks = 0